// Intro.jsx (FULL) — păstrează logica ta, doar trece pe clase (template dark)
import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "../../styles/about/IntroMap.css";

// Fix pentru iconițele de Marker în bundlere moderne (CRA/Vite)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const center = [47.77928270318022, 27.925899753262268];

export default function Intro() {
  return (
    <section className="srMap">
        <div className="srMap_frame" role="region" aria-label="Hartă locație">
        <MapContainer center={center} zoom={14} className="srMap_leaflet" zoomControl>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; OpenStreetMap contributors"
          />
          <Marker position={center}>
            <Popup>Bălți, str. Kiev 48A</Popup>
          </Marker>
        </MapContainer>
      </div>
    </section>
  );
}